var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrivatePics(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/GallerY") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.2552727,0.250909091 L15.2552727,14.6029091 C15.2552727,14.9631996 14.9631996,15.2552727 14.6029091,15.2552727 L0.250909091,15.2552727 C0.250909091,15.9758537 0.835055388,16.56 1.55563636,16.56 L14.6029091,16.56 C15.6837806,16.56 16.56,15.6837806 16.56,14.6029091 L16.56,1.55563636 C16.56,0.835055388 15.9758537,0.250909091 15.2552727,0.250909091 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9198824,14.9675882 L16.9198824,1.95229412 C16.9198824,0.874071849 16.0458105,1.44498792e-16 14.9675882,0 L1.95229412,0 C0.874071849,-1.44498792e-16 1.44498792e-16,0.874071849 0,1.95229412 L0,14.9675882 C1.44498792e-16,16.0458105 0.874071849,16.9198824 1.95229412,16.9198824 L14.9675882,16.9198824 C16.0458105,16.9198824 16.9198824,16.0458105 16.9198824,14.9675882 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8926008,11.035293 C13.929369,11.035293 15.583286,12.7363338 15.5986,14.831134 L15.5986,15.3193957 C15.5986,15.5871521 15.3995174,15.791907 15.1391786,15.791907 L6.97679203,15.791907 L1.44842138,15.791907 C1.1880826,15.791907 0.989,15.5871521 0.989,15.3193957 L0.989,14.9413866 C0.989,13.2403458 2.33663606,11.8543126 3.99055304,11.8543126 L6.3336021,11.8543126 C6.39485828,11.8543126 6.45611447,11.870063 6.5020566,11.8858134 C7.12993249,11.3503006 7.94157694,11.035293 8.81447757,11.035293 L11.8926008,11.035293 Z M10.58,8.59944444 C9.19174359,8.59944444 8.05,7.47067521 8.05,6.06944444 C8.05,4.68118803 9.17876923,3.53944444 10.58,3.53944444 C11.9812308,3.53944444 13.11,4.66821368 13.11,6.06944444 C13.11,7.47067521 11.9812308,8.59944444 10.58,8.59944444 Z M4.6,9.51944444 C3.46415385,9.51944444 2.53,8.59590598 2.53,7.44944444 C2.53,6.31359829 3.45353846,5.37944444 4.6,5.37944444 C5.74646154,5.37944444 6.67,6.30298291 6.67,7.44944444 C6.67,8.59590598 5.74646154,9.51944444 4.6,9.51944444 Z",
    id: "path-5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RHP-Search--Desktop-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile-5-Friend-Request",
    transform: "translate(-141.000000, -801.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Photos",
    transform: "translate(120.000000, 512.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Private-pics",
    transform: "translate(20.060060, 288.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/PhotoGallery-Max"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.840000, 1.840000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/dark-grey",
    transform: "translate(2.760000, 2.760000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)",
    fill: "#646464"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.021818, -6.021818)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 25,
    height: 25
  })))), /*#__PURE__*/React.createElement("g", {
    id: "colour/dark-grey-copy"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/dark-grey",
    mask: "url(#mask-4)",
    fill: "#646464"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.003529, -3.003529)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-5"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivatePics);
export default __webpack_public_path__ + "static/media/privatePics.d324dd5fa41d715f61d5a5e1728d398a.svg";
export { ForwardRef as ReactComponent };